package com.example.mystybag.common.ui.components.custom

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.platform.LocalDensity
import com.example.mystybag.common.extensions.doOnClick
import com.example.mystybag.common.extensions.modifyIf
import com.example.mystybag.core.ui.theme.LocalTheme.p15
import com.example.mystybag.core.ui.theme.LocalTheme.p34
import com.example.mystybag.core.ui.theme.LocalTheme.p2
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p52
import com.example.mystybag.core.views.AppTheme

@Composable
fun SwitchButton(
    modifier        : Modifier = Modifier,
    checked         : Boolean,
    isClickable     : Boolean  = true,
    onStateChange   : (Boolean) -> Unit
) {
    val width           = p52
    val height          = p32
    val gap             = p2
    val thumbRadius     = (height / 2) - gap
    val colors          = AppTheme.current.colors

    val animatePosition = animateFloatAsState(
        targetValue = if (checked)
            with(LocalDensity.current) { (width - thumbRadius - gap).toPx() }
        else
            with(LocalDensity.current) { (thumbRadius + gap).toPx() },
        label = ""
    )

    Canvas(
        modifier = modifier
            .size(width = width, height = height)
            .clip(RoundedCornerShape(p15))
            .modifyIf(isClickable) { doOnClick { onStateChange(!checked) } }
    ) {
        drawRoundRect(
            color           = if (checked) colors.primary else colors.surfaceContainerHighest,
            cornerRadius    = CornerRadius(x = p15.toPx(), y = p15.toPx())
        )

        drawCircle(
            color  = colors.onPrimary,
            radius = thumbRadius.toPx(),
            center = Offset(
                x  = animatePosition.value,
                y  = size.height / 2
            )
        )
    }
}

/*@Preview
@Composable
fun SwitchButtonPreview(){
    AppTheme.setup(false)
    AppThemeView {
        SwitchButton(Modifier, false, {})
    }
}*/